import React, { useState, useEffect } from 'react';
import { useMappedState, useDispatch } from 'redux-react-hook';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { Authenticate } from "../../store/authentication/actions";
import { useHistory } from "react-router-dom";
import BankIpComponent from '../Bank/BankIpComponent';
import { DestroySession } from '../../store/global/actions';

const style = {
  height: 500,
  width: 400,
  margin: 20,
  textAlign: 'center',
  display: 'inline-block',
};

const padding = {
  padding: 10
}

const mapState = state => ({
  authentication: state.authentication,
});

const Login = () => {

  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const { authentication } = useMappedState(mapState);
  const dispatch = useDispatch();
  const history = useHistory();

  const authenticate = (id, password) => {
    dispatch(Authenticate(id, password));
  }

  const handleChangeId = (e) =>{
    setId(e.target.value);
  }

  const handleChangePassword = (e) =>{
    setPassword(e.target.value);
  }

  useEffect(() => { 
    if (authentication) history.push('/messages')
    else dispatch(DestroySession());

  }, [authentication])

  return (
    <div style={style}>
      <div style={padding}>Wpisz ID oraz hasło aby zalogować się.</div>
      <div style={padding}><TextField label="ID" name="id" value={id} onChange={handleChangeId} /></div>
      <div style={padding}><TextField label="Hasło" value={password} onChange={handleChangePassword} type="password" /></div>
      <div style={padding}><Button variant="raised" color="primary" onClick={() => authenticate(id, password)}>OK</Button></div>
      <div style={padding}><BankIpComponent /></div>
    </div>
  )

}

export default Login



// WEBPACK FOOTER //
// ./src/components/Login/Login.js